export function createHttpClient({
  baseUrl,
  getDefaultHeaders,
  onUnauthorized,
  credentials = 'include'
}) {
  async function request(path, options = {}) {
    const { headers: requestHeaders = {}, body, ...restOptions } = options;

    const headers = {
      ...(typeof getDefaultHeaders === 'function' ? getDefaultHeaders(options) : {}),
      ...requestHeaders
    };

    const response = await fetch(`${baseUrl}${path}`, {
      ...restOptions,
      credentials,
      headers,
      body
    });

    if (response.status === 204) return null;

    const contentType = response.headers.get('content-type') || '';
    const isJson = contentType.includes('application/json');
    const data = isJson ? await response.json() : null;

    if (!response.ok) {
      if (response.status === 401 && typeof onUnauthorized === 'function') {
        onUnauthorized({ path, options, response, data });
      }

      const error = new Error(data?.message || data?.error || 'API greška.');
      error.code = data?.code || null;
      error.status = response.status;
      throw error;
    }

    return data;
  }

  return {
    request
  };
}
